import { Result } from 'antd';
import styled from 'styled-components';

export const StyledResult = styled(Result)`
  padding: 0;

  .ant-result-icon {
    margin-bottom: 0;

    .anticon {
      font-size: 32px;
    }
  }
`;

export const StyledTitle = styled.div`
  .title {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: #242424;
  }

  sup {
    color: #999;
    margin-left: 10px;
  }
`;
